import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HouseholdService } from 'app/services/household-service';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { IWellViewModel } from 'app/models/well/well.viewmodel';
import { MatTableDataSource } from '@angular/material/table';
import { IHousehold } from 'app/models/household/household';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FormControl, FormGroup } from '@angular/forms';
import { HouseholdSearch } from 'app/models/household/household-search';
import { HouseholdAssociation } from 'app/models/household/household-association';
import { Search } from 'app/models/well/search/search';
import { ISearchResult } from 'app/models/well/search/search.result';

/*
 * Merge Well Dialog
 */
@Component({
    selector: 'dialog-associate-household-well',
    templateUrl: 'associate-household-well-dialog.html',
    styleUrls: ['./associate-household-well-dialog.scss']
  })
  export class DialogAssociateWellToHouseholdComponent implements OnInit  {
    pageSize = 20;
    loading: boolean = false;
    applicationId: number = 0;
    household: IHousehold = null;
    houseHolds: IHousehold[] = [];
    well: IWellViewModel = null;
    wells: ISearchResult[] =[];
    searchResultsCount: number = 0;
    selectedHouseholdId: number = 0;
    selectedWellId: number = 0;
    association: HouseholdAssociation = {
      wellId: 0,
      householdId: 0,
      voucherId: 0,
      housingUnitId: 0,
      housingUnitStartDate: '',
      housingUnitEndDate: ''
    }

    householdSearchForm = new FormGroup({
      id: new FormControl(),
      contactName: new FormControl(''),
      address1: new FormControl(''),
      city: new FormControl(''),
      zip: new FormControl(''),
      county: new FormControl(''),
      personsInHousehold: new FormControl(0),
      pregnancyInHousehold: new FormControl(false),
      waterTreamentProvided : new FormControl(false),
      bottledWaterProvided : new FormControl(false),
      infantsUnder1 : new FormControl(false),
      age1to4: new FormControl(false),
      age5to9 : new FormControl(false),
      age10to14 : new FormControl(false),
      age15to19: new FormControl(false),
      age20to29: new FormControl(false),
      age30to39: new FormControl(false),
      age40to49: new FormControl(false),
      age50to59 : new FormControl(false),
      age60to69: new FormControl(false),
      age70to79 : new FormControl(false),
      age80Plus : new FormControl(false)
    });

    householdSearch: HouseholdSearch = {
      id: "",
      contactName: "",
      address1: "",
      city: "",
      zip: "",
      searchText: "",
      county: "",
      pregnancyInHousehold: false,
      infantsUnder1: false,
      age1to4: false,
      age5to9: false,
      age10to14: false,
      age15to19: false,
      age20to29: false,
      age30to39: false,
      age40to49: false,
      age50to59: false,
      age60to69: false,
      age70to79: false,
      age80Plus: false,
      waterTreamentProvided: false,
      bottledWaterProvided: false,
      age15AndBelow: false,
      age16AndAbove: false,
      infantsInHousehold: false,
      searchBy: 'Household',
      searchResultsMaxRows: ''
    };

    wellSearchForm = new FormGroup({
      wellId: new FormControl(this.oregonWellDataService.search.wellId),
      sampleId: new FormControl(this.oregonWellDataService.search.sampleId),
      contaminant: new FormControl(this.oregonWellDataService.search.contaminant),
      county: new FormControl(this.oregonWellDataService.search.county),
      address: new FormControl(this.oregonWellDataService.search.address),
      city: new FormControl(this.oregonWellDataService.search.city),
      zip: new FormControl(this.oregonWellDataService.search.zip),
      wellTag: new FormControl(this.oregonWellDataService.search.wellTag),
      wellLog: new FormControl(this.oregonWellDataService.search.wellLog),
      startDate: new FormControl(this.oregonWellDataService.search.startDate),
      endDate: new FormControl(this.oregonWellDataService.search.endDate),
      createStartDate: new FormControl(this.oregonWellDataService.search.createStartDate),
      createEndDate: new FormControl(this.oregonWellDataService.search.createEndDate),
      receivedStartDate: new FormControl(this.oregonWellDataService.search.receivedStartDate),
      receivedEndDate: new FormControl(this.oregonWellDataService.search.receivedEndDate),
      searchBy: new FormControl(this.oregonWellDataService.search.searchBy),
      voucherType: new FormControl(this.oregonWellDataService.search.voucherType)
    });

    wellSearch: Search = {
      wellId: '',
      sampleId: '',
      contaminant: [],
      address: '',
      county: '',
      city: '',
      state: '',
      zip: '',
      wellTag: '',
      wellLog: '',
      startDate: '',
      endDate: '',
      createStartDate: '',
      createEndDate: '',
      receivedStartDate: '',
      receivedEndDate: '',
      isValidated: false,
      searchBy: 'Well',
      searchResultsMaxRows: '',
      voucherType: '',
      voucherOhaId: '',
      voucherIdentifier: ''
    }

    @ViewChild(MatSort) sort: MatSort;
    displayedColumns: string[] = ['action','id', 'contactName','address1','city','zip','county', 'waterTreamentProvided', 'bottledWaterProvided', 'personsInHousehold'];
    dataSource = new MatTableDataSource(this.houseHolds);
    displayedColumnsWells: string[] = ['action','id','address','city','zip','county'];
    dataSourceWells = new MatTableDataSource<ISearchResult>(this.wells);
    @ViewChild('TablePaginator') paginator: MatPaginator;
    // @ViewChild('TableSort') sort: MatSort;
  
    filterTable(event: Event) {
      let value = (event.target as HTMLInputElement).value;
      this.dataSource.filter = value.trim().toLowerCase();
    }
    
    constructor(public householdService: HouseholdService, 
                public oregonWellDataService: OregonWellDataService,
                private toastr: ToastrService, 
                @Inject(MAT_DIALOG_DATA) public data: HouseholdAssociation,
                private dialogRef: MatDialogRef<DialogAssociateWellToHouseholdComponent>)
                 {
                  this.loading = true;
                  this.association = this.data;
                  this.loading = false;

    }

    ngOnInit(): void {
      this.load()   
    }

    load() {
      if(this.association.wellId > 0) {
        this.loading = true;
        this.oregonWellDataService.GetEditWell(this.association.wellId).subscribe(result => {
          this.well = result;
          this.householdSearchForm.controls['address1'].setValue(this.well.address1);
          this.householdSearchForm.controls['city'].setValue(this.well.city);
          this.householdSearchForm.controls['zip'].setValue(this.well.zip);
          this.householdSearchForm.controls['county'].setValue(this.well.county);
          this.searchHouseholds();
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
            this.loading = false;
          }
        );
      }

      if(this.association.householdId > 0) {        
        this.loading = true;
        this.householdService.getHouseholdById(this.association.householdId).subscribe(result => {
          this.household = result;
          this.wellSearchForm.controls['address'].setValue(this.household.address1);
          this.wellSearchForm.controls['city'].setValue(this.household.city);
          this.wellSearchForm.controls['zip'].setValue(this.household.zip);
          this.wellSearchForm.controls['county'].setValue(this.household.county);
          this.searchWells();
          this.loading = false;
        },
          error => {
            this.oregonWellDataService.onHttpError(error);
            this.loading = false;
          }
        );
      }
    }

    searchHouseholds() {
      this.setHouseholdSearchFieldsFromForm();
      if(!this.validHouseholdSearch()) {
        return;
      }
      this.loading = true;
      this.householdService.Search(this.householdSearch).subscribe(
        result => {
          this.houseHolds = result;
          this.loading = false;
        },
        error => {
          this.loading = false;
        },
        () => {
          this.dataSource = new MatTableDataSource<IHousehold>(this.houseHolds);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }

    validHouseholdSearch(): boolean {
      if((this.householdSearch.address1.length == 0) &&
         ( this.householdSearch.city.length == 0) &&
         (this.householdSearch.zip.length == 0) &&
         (this.householdSearch.county.length == 0) &&
         (this.householdSearch.contactName.length == 0) )
      {
        this.toastr.error('Invalid Search.  Please refine.');
        return false;
      }
      return true;
    }

    searchWells() {
      this.setWellSearchFieldsFromForm();
      if(!this.validWellSearch()) {
          return;
      }
      this.loading = true;
      this.oregonWellDataService.Search(this.wellSearch).subscribe(
        result => {
          this.wells = result;
          this.dataSourceWells = new MatTableDataSource<ISearchResult>(this.wells);
          this.loading = false;
        },
        error => {
          this.loading = false;
        },
        () => {
        }
      );
    }

    validWellSearch(): boolean {
      if((this.wellSearch.address.length == 0) &&
         ( this.wellSearch.city.length == 0) &&
         (this.wellSearch.zip.length == 0) &&
         (this.wellSearch.county.length == 0) &&
         (this.wellSearch.wellLog.length == 0) &&
         (this.wellSearch.wellTag.length == 0)) 
      {
        this.toastr.error('Invalid Search.  Please refine.');
        return false;
      }
      return true;
    }

    reset() {
      this.householdSearchForm.reset();
      this.wellSearchForm.reset();
    }

    setHouseholdSearchFieldsFromForm() {
      this.householdSearch.contactName = this.householdSearchForm.value.contactName;
      this.householdSearch.county = this.householdSearchForm.value.county;
      this.householdSearch.address1 = this.householdSearchForm.value.address1;
      this.householdSearch.city = this.householdSearchForm.value.city;
      this.householdSearch.zip = this.householdSearchForm.value.zip;
      this.householdSearch.county = this.householdSearchForm.value.county;
    }

    setWellSearchFieldsFromForm() {
      this.wellSearch.county = this.wellSearchForm.value.county;
      this.wellSearch.address = this.wellSearchForm.value.address;
      this.wellSearch.city = this.wellSearchForm.value.city;
      this.wellSearch.zip = this.wellSearchForm.value.zip;
      this.wellSearch.county = this.wellSearchForm.value.county;
      this.wellSearch.searchResultsMaxRows = '10';
    }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
    
    }

    onChangeSelectedHousehold(householdId: number) {
      this.selectedHouseholdId = householdId;
    }

    onChangeSelectedWell(wellId: number) {
      this.selectedWellId = wellId;
    }

    associateWell() {
      this.loading = true;
      let idWell = this.selectedWellId > 0 ? this.selectedWellId : this.association.wellId;
      let idHousehold = this.selectedHouseholdId > 0 ? this.selectedHouseholdId : this.association.householdId;
      this.householdService.associateHouseholdToWell(idHousehold, idWell).subscribe(
        result => {          
          this.toastr.success("Well/Household Associated");
          this.loading = false;
          this.dialogRef.close();
        },
        error => {
          this.toastr.error("Unable to Associate Well/Household");
          this.selectedHouseholdId = 0;
          this.loading = false;
        }
      );
    }

    associateVoucher() {
      this.loading = true;
      let idVoucher = this.selectedWellId > 0 ? this.selectedWellId : this.association.voucherId;
      let idHousehold = this.selectedHouseholdId > 0 ? this.selectedHouseholdId : this.association.householdId;
      this.householdService.associateHouseholdToVoucher(idHousehold, idVoucher).subscribe(
        result => {          
          this.toastr.success("Voucher/Household Associated");
          this.loading = false;
          this.dialogRef.close();
        },
        error => {
          this.toastr.error("Unable to Associate Voucher/Household");
          this.selectedHouseholdId = 0;
          this.loading = false;
        }
      );
    }
  }